import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/app/shared/base/base-component';
import { AuthService } from 'src/app/shared/providers/auth/auth-service.service';

@Component({
  selector: 'app-email-activation',
  templateUrl: './email-activation.component.html',
  styleUrls: ['./email-activation.component.scss']
})
export class EmailActivationComponent extends BaseComponent implements OnInit, OnDestroy {
  id: string = window.location.hash.substring(1);
  isInvalid: boolean = false;
  isExpired: boolean = false;
  isActivated: boolean = false;
  invalidMessage: string = '';
  constructor(
    private route: ActivatedRoute,
    private authService: AuthService
  ) {
    super(true);
  }

  ngOnInit(): void {
    if (this.id) {
      this.verify(this.id);
    }
    else
      this.translate.get('EmailActivation.InvalidLink').subscribe(msg => {
        this.isInvalid = true;
        this.invalidMessage = msg;
      });
    ;
  }

  ngOnDestroy(): void {
    this.subscription.forEach((sb) => sb.unsubscribe());
  }

  private verify(id: string) {
    const sub = this.authService.emailActivation(id)
      .subscribe(() => {
        this.isInvalid = false;
        this.isExpired = false;
        this.isActivated = true;
      }, error => {
        if (error.status === 403 && error.error.error.message === 'ExpiredLink') {
          this.isInvalid = false;
          this.isExpired = true;
          this.isActivated = false;
        }
        else if (error.status === 403 && error.error.error.message === 'EmailAlreadyExists') {
          this.translate.get('EmailActivation.EmailAlreadyExists').subscribe(msg => {
            this.isInvalid = true;
            this.isExpired = false;
            this.isActivated = false;
            this.invalidMessage = msg;
          });
        }
        else if (error.status === 403 && error.error.error.message === 'JobIDAlreadyExists') {
          this.translate.get('EmailActivation.JobIDAlreadyExists').subscribe(msg => {
            this.isInvalid = true;
            this.isExpired = false;
            this.isActivated = false;
            this.invalidMessage = msg;
          });
        }

        else {
          this.translate.get('EmailActivation.InvalidLink').subscribe(msg => {
            this.isInvalid = true;
            this.isExpired = false;
            this.isActivated = false;
            this.invalidMessage = msg;
          });
        }

        return this.logException(error);
      });

    this.subscription.push(sub);
  }

}
